import { buildStaffMenu } from "./staffMenu"
// Also available for Legal-specific tweaks: overrideByKey, removeByKey, addItems from "./helpers"

/**
 * Legal role menu — cloned from the shared staff base.
 *
 * Currently mirrors the staff base exactly. To add Legal-specific overrides
 * without affecting other roles, edit only this file. Example:
 *
 *   const menu = buildStaffMenu()
 *   return removeByKey(menu, "leave-request")
 */
export const buildLegalMenu = () => buildStaffMenu()
